import { render, staticRenderFns } from "./mainComponent.vue?vue&type=template&id=7dd9170a&scoped=true&"
import script from "./mainComponent.vue?vue&type=script&lang=js&"
export * from "./mainComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd9170a",
  null
  
)

export default component.exports